import styled from "styled-components";
import { colors } from "../../../../../consts";
import { Paragraph2, WrapperContainer } from "../../../../../components";
import { Circle } from "../LineChartTooltip/styled";

export const MetricsInfoContainer = styled(WrapperContainer)`
  ${Paragraph2} {
    color: ${colors.WHITE};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    b {
      font-weight: 700;
    }
  }

  ${Circle} {
    margin-top: 6px;
  }
`;
